'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Map param
 * @param {*} value
 */
var mapParam = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
    var type, result, key;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(value === null || value === undefined)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', {});

          case 2:
            type = typeof value === 'undefined' ? 'undefined' : _typeof(value);


            if (value.constructor && value.constructor.name) {
              type = value.constructor.name;
            }

            if (!(type === 'Object')) {
              _context.next = 15;
              break;
            }

            result = {
              type: type,
              params: {}
            };
            _context.t0 = regeneratorRuntime.keys(value);

          case 7:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 14;
              break;
            }

            key = _context.t1.value;
            _context.next = 11;
            return mapParam(value[key]);

          case 11:
            result.params[key] = _context.sent;
            _context.next = 7;
            break;

          case 14:
            return _context.abrupt('return', result);

          case 15:
            if (!(type === 'Array')) {
              _context.next = 21;
              break;
            }

            _context.t2 = type;
            _context.next = 19;
            return Promise.all(value.map(mapParam));

          case 19:
            _context.t3 = _context.sent;
            return _context.abrupt('return', {
              type: _context.t2,
              params: _context.t3
            });

          case 21:
            if (!(type === 'Promise')) {
              _context.next = 31;
              break;
            }

            _context.t4 = type;
            _context.t5 = mapParam;
            _context.next = 26;
            return value;

          case 26:
            _context.t6 = _context.sent;
            _context.next = 29;
            return (0, _context.t5)(_context.t6);

          case 29:
            _context.t7 = _context.sent;
            return _context.abrupt('return', {
              type: _context.t4,
              param: _context.t7
            });

          case 31:
            return _context.abrupt('return', {
              type: type
            });

          case 32:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function mapParam(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fs = require('fs');
var getFilenames = require('./filenames');
var Inspector = function () {
  /**
   * Constructor
   * @param {string} filename
   * @param {function} onUpdate
   */
  function Inspector(filename, onUpdate) {
    _classCallCheck(this, Inspector);

    this.calls = [];
    this.onUpdate = onUpdate || function (calls) {
      fs.writeFileSync(getFilenames(filename).inspect, JSON.stringify(calls));
    };
  }

  /**
   * Handle call
   * @param {number} index
   * @param {Object[]} params
   * @param {*} returns
   */


  _createClass(Inspector, [{
    key: 'handleCall',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(index, params, returns) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.calls[index]) this.calls[index] = [];
                _context2.t0 = this.calls[index];
                _context2.next = 4;
                return Promise.all(params.map(mapParam));

              case 4:
                _context2.t1 = _context2.sent;
                _context2.next = 7;
                return mapParam(returns);

              case 7:
                _context2.t2 = _context2.sent;
                _context2.t3 = {
                  params: _context2.t1,
                  returns: _context2.t2
                };

                _context2.t0.push.call(_context2.t0, _context2.t3);

                this.onUpdate(this.calls);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCall(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return handleCall;
    }()
  }, {
    key: 'inspectInline',
    value: function inspectInline(index) {
      for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      var that = this;
      // eslint-disable-next-line accessor-pairs
      return {
        set returns(value) {
          Inspector.promises.push(that.handleCall(index, params, value));
        }
      };
    }
  }, {
    key: 'inspect',
    value: function inspect(index, func) {
      for (var _len2 = arguments.length, params = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        params[_key2 - 2] = arguments[_key2];
      }

      var returns = func.apply(undefined, params);
      Inspector.promises.push(this.handleCall(index, params, returns));
      return returns;
    }
  }]);

  return Inspector;
}();

Inspector.promises = [];

module.exports = Inspector;


//////////////////
// WEBPACK FOOTER
// ../lib/Inspector.js
// module id = 492
// module chunks = 0